<template>
  <div id="app">
    <Header></Header>
    <router-view></router-view>
  </div>
</template>

<script>
import Header from "@/components/PublicCom/Header";
export default {
  name: "App",
  components: {
    Header,
  },
};
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0px;
  list-style: none;
  outline: none;
  text-decoration: none;
  text-align: center;
}
#app {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background-image: url("@/assets/images/bg0.png");
  background-size: cover;
  background-repeat: no-repeat;
  color: white;
}
</style>
